import { useEffect, useState } from "react";

const EVENTS = ["pointermove", "pointerdown", "keydown", "scroll", "wheel", "touchstart"] as const;

/**
 * Whether the page is idle: hidden (another tab, minimised), or nobody has used it for `ms`. Pages that poll stop
 * while it's idle and pick up when someone's back (Chad, 2026-10-10: nothing runs for an idle browser).
 */
export function useIdle(ms = 15 * 60_000) {
  const [idle, setIdle] = useState(() => typeof document !== "undefined" && document.visibilityState === "hidden");
  useEffect(() => {
    let last = Date.now();
    const check = () => setIdle(document.visibilityState === "hidden" || Date.now() - last > ms);
    const touch = () => {
      last = Date.now();
      check();
    };
    for (const e of EVENTS) window.addEventListener(e, touch, { passive: true });
    document.addEventListener("visibilitychange", touch);
    const t = setInterval(check, 30_000);
    return () => {
      for (const e of EVENTS) window.removeEventListener(e, touch);
      document.removeEventListener("visibilitychange", touch);
      clearInterval(t);
    };
  }, [ms]);
  return idle;
}
